export default __webpack_public_path__ + "static/media/west-elevation.56c15729.png";